import React from "react";
import { Link } from "react-router-dom";
import { Row, Col, Image, } from "react-bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import { useUserContext } from "./../../context/userContext";
import downloadIcon from "./../../assets/download.svg";
import "./sidebar.css";

function Sidebar({ active }) {
  const userContext = useUserContext();

  const navBar = () => {
    return (
      <div className="h-100 w-100">
        <Row className="d-flex align-items-start flex-column menu-height">{navBarItems()}</Row>
        <Row className="text-center align-items-end user-name-bgc border-top border-bottom" style={{ height: "50px" }}>
            <div className="d-flex align-items-center  mb-1">
              <div className="h-100 w-100 text-center">{userContext && userContext.user != null ? userContext.user.name : ''}</div>
            </div>
        </Row>
      </div>
    );
  };

  const navBarItems = () => {
    return (
      <div className="w-100">
        <Link to={{ pathname: '/Devices'}} className="btn btn-outline-secondary mt-2 w-100 text-start">
          <Image src={downloadIcon} style={{ width: 30 }} />
          <span className="p-2">Devices</span>
        </Link>
      </div>
    );
  };

  return (
    <Col id="sidebar" className="App-menu col-3 text-center pt-4" style={{ maxWidth: 250 }}>
      {active ? navBar() : ""}
    </Col>
  );
}

function SidebarTop({ active }) {

  return (
    <Col id="sidebarTop" className="topbar w-100">
      {active ?
        <Row className="p-2">
          <Col>
            <Link to={{ pathname: '/Devices' }} className="btn btn-outline-secondary text-start">
              <Image src={downloadIcon} style={{ width: 20 }} />
              <span className="p-2">Devices</span>
            </Link>
          </Col>
        </Row>
        : ""}
    </Col>
  );
}

export { Sidebar, SidebarTop }